<template>
  <div id="externalHeader" :class="{'has-version': version}">
    
    <div class="logo"></div>
    <div v-if="version" class="version"><span class="mobile-only">v</span>{{ version }}</div>
    <div class="header-title">{{ title }}</div>
    <div class="login" @click="openLink(appUrl)">LOGIN</div>

  </div>
</template>


<script>

  export default {
    data () {
      return {

      }
    },

    computed: {
      appUrl () {
        return APP_URL;
      },
    },

    props: {

      version: {
        type: String
      },

      title: {
        type: String
      }

    },

    methods: {

      openLink (link) {
        window.open(link, '_self');
      }

    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #externalHeader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: #FFF;
    height: 100px;
    border-bottom: $borderBlack12;

    .mobile-only {
      display: none;
    }

    .header-title {
      font-size: 24px;
    }

    .logo {
      position: absolute;
      width: 140px;
      height: 80px;
      top: 8px;
      left: 8px;

      background-image: url('../assets/logos/vilio-black.svg'); 
      @include backgroundCenter;
    }

    .version {
      @include fontPrimary400;

      position: absolute;
      top: 72px;
      left: 70px;
      color: $black54;
    }

    .header-title {
      display: none;
    }

    .login {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      padding: 0 16px;
      box-sizing: border-box;
      line-height: 100px;
      font-size: 16px;
      cursor: pointer;

      @include fontPrimary400;
      color: $black54;

    }

    &.has-version {
      height: 108px;

      .login {
        line-height: 108px;
      }
    }

    @media screen and (max-width: 780px) {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 64px !important;
      background: $primary;

      .mobile-only {
        display: inline-block;
      }

      .logo {
        width: 48px;
        height: 48px;
        background-image: url('../assets/icons/icon-48.png'); 
      }

      .header-title {
        display: block;
        position: absolute;
        
        top: 0px;
        left: 72px;
        bottom: 0;
        line-height: 64px;
        right: 75px;
        font-size: 20px;
        color: #FFF;

        @include textEllipsis;
      }

      .version {
        top: 36px;
        left: 72px;
        color: $white;
        font-size: 12px;
        right: 75px;
        color: rgba(255, 255, 255, .78);

        @include textEllipsis;
      }

      .login {
        line-height: 64px !important;
      }

    }

    &.has-version {

      .header-title {
        top: 10px;
        left: 72px;
        right: 75px;
        font-size: 20px;
        line-height: normal;
      }

    }
  }

</style>


// WEBPACK FOOTER //
// src/components/ExternalHeader.vue